<template>
  <basic-dialog :visible="visible"
                :title="title"
                :width="900"
                :update-vis="updateVis"
                :handle-close="handleClose"
                :handle-closed="handleClosed"
                :handle-ok="handleOk">
    <el-form ref="form"
             size="small"
             label-position="right"
             label-width="80px"
             :model="dto"
             :rules="rules"
             @submit.native.prevent>
      <div class="entity-dlg__block">
        <div class="entity-dlg__block-bd formFix">
          <el-row :gutter="24">
            <el-col :span="20">
              <!-- <el-form-item label="软件系统"
                            prop="appCode"
                            style="display:inline-block;">
                <el-select v-model="appCode"
                           @change="onAppChange">
                  <el-option v-for="item in appList"
                             :key="item.appCode"
                             :value="item.appCode"
                             :label="item.appName"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item :label="$t('language.5o6up3960k80')"
                            prop="name"
                            style="display:inline-block;">
                <el-input v-model="roleCode"
                          :placeholder="$t('language.5o6up3960k80')"
                          :maxlength="30"
                          clearable />
              </el-form-item>
              <el-form-item :label="$t('language.5o6up3960fo0')"
                            prop="name"
                            style="display:inline-block;">
                <el-input v-model="roleName"
                          :placeholder="$t('language.5o6up3960fo0')"
                          :maxlength="30"
                          clearable />
              </el-form-item>
            </el-col>
            <el-button type="primary"
                       size="small"
                       @click="query">{{$t('language.5o6trh9vn600')}}</el-button>
            <el-button size="small"
                       @click="reset">{{$t('language.5o6trh9vn900')}}</el-button>
          </el-row>
        </div>
      </div>
    </el-form>
    <template>
      <basic-list ref="userTB"
                  :show-select-col="true"
                  :show-action-col="false"
                  :loading="false"
                  :fields="fields"
                  :total="menuList ? menuList.total : 0"
                  :list="menuList ? menuList.list : []"
                  :selection-change="selectionChange"
                  :page-index-change="pageIndexChange"
                  :page-size-change="pageSizeChange"
                  :page-size="pageSize">
      </basic-list>
    </template>
  </basic-dialog>
</template>

<script>
// 添加或编辑用户
import EntityDialog from '@/mixins/entityDialog'
import ExactList from '@/mixins/exactList'
import { mapState } from 'vuex'
export default {
  mixins: [EntityDialog, ExactList],
  data() {
    return {
      rules: {},
      pageSize: 10,
      appCode: '',
      roleName: '',
      roleCode: '',
      menuList: null,
      cascaderVal: '',
      // 设置翻页触发接口名
      apiName: 'listMenuRole',
      apiIdList: [],
      pickIdList: [],
      fields: [
        { key: 'roleCode', name: this.$t('language.5o6up3960k80') },
        { key: 'roleName', name: this.$t('language.5o6up3960fo0') },
        { key: 'roleSource', name: this.$t('language.5o6otz4p1ps0') },
      ]
    }
  },
  computed: {
    ...mapState('app', ['appList']),
  },
  props: {
    selectItem: {
      type: Object,
      default() {
        return {}
      }
    },
    winClose: {
      type: Function,
      default() {
        return () => { }
      }
    }
  },
  watch: {
    'state.menuList': {
      deep: true,
      immediate: true,
      handler: function (newVal) {
        this.menuList = newVal
        this.giveCheck()
      }
    }
  },
  methods: {
    // 弹出触发
    setAppCode() {
      // this.appCode = this.appList[0].appCode
      // this.$parent.updateState({ appCode: this.appCode })
      this.query()
    },
    // 查询
    query(ev) {
      this.$parent.updateState({ roleName: this.roleName, roleCode:this.roleCode,menuPageIndex: 0 })
      // 查询 设置菜单角色列表
      this.$parent.dispatch('listMenuRole')
    },
    // 重置
    reset() {
      this.roleName = ''
      this.roleCode = ''
      this.$parent.updateState({ roleName: this.roleName,roleCode:this.roleCode })
      // 查询 设置菜单角色列表
      this.$parent.dispatch('listMenuRole')
    },
    handleOk() {
      if (!this.$refs.form) {
        return
      }
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }
        let params = this.toEnd()
        this.handleSave({ params, type: this.action })
      })
    },
    // 关闭和取消按钮
    handleClose(ev) {
      this.winClose(ev)

    },
    handleChange(ev) {
    },
    // 选择触发事件 获取当前行数据
    selectionChange(rows, ind) {
      this.pickIdList.length = 0
      rows.forEach((item) => {
        this.pickIdList.push(item.id)
      })
      this.$parent.updateState({ pickIdList: this.pickIdList })
    },
    giveCheck() {
      // 设置数据勾选
      const self = this;
      setTimeout(() => {
        this.apiIdList.length = 0
        this.menuList && this.menuList.list && this.menuList.list.forEach((item, ind) => {
          const _table = self.$refs.userTB.$refs.table
          // 设置状态
          item && _table.toggleRowSelection(item, !!item.tenementId)
          // 存储id
          this.apiIdList.push(item.id)
        })
        if (this.apiIdList.length > 0) {
          this.$parent.updateState({ apiIdList: this.apiIdList })
        }
      })

    },
    // 切换页数
    pageIndexChange(_index) {
      let _ind = _index - 1
      // 更新页面数据
      this.$parent.updateState({ menuPageIndex: _ind })
      // 查询列表
      this.$parent.dispatch(this.apiName || 'queryList')
    },
    // 切换每页显示条数
    pageSizeChange(_size) {
      // 查询列表
      this.pageSize = _size
      this.$parent.updateState({ menuPageSize: _size })
      // 查询列表
      this.$parent.dispatch(this.apiName || 'queryList')
    },
  }
}
</script>

<style lang="scss" scope>
.entity-dlg__block-bd.formFix {
  input {
    width: 200px;
  }
  .col-r {
    float: right;
    position: relative;
    padding: 0 12px 0 25px;
    width: 162px;
    .el-button {
      width: 75px;
    }
  }
}
</style>